// extracted by mini-css-extract-plugin
export default {"splashScreen":"SplashScreen_splashScreen__B5I9w","backgroundImg":"SplashScreen_backgroundImg__vWynL","z55":"SplashScreen_z55__XsR0b"};